/* Import Public Sans font - must be first */
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

/* Tailwind scans every file for class names. Skip the tests, so words in test
   names never end up in the production CSS. */
@source not './**/__tests__';
@source not './test';
@source not '../vitest.config.ts';

/* Base styles */
body {
  font-family: 'Public Sans', sans-serif;
  margin: 0;
  padding: 0;
}

#root {
  min-height: 100vh;
}
